const ProgramTypeConfig = {
  spp: {
    text: 'how to find an Adobe Solution partner.',
    link: 'https://solutionpartners.adobe.com/solution-partners/find_adobe_partner.html',
    sortingList: [
      { value: 'default', name: 'Default' },
      { value: 'specializations', name: 'Number of specializations' },
      { value: 'certifications', name: 'Number of certifications' },
      { value: 'customerDeployments', name: 'Number of customer deployments' },
      { value: 'level', name: 'Partner level' },
      { value: 'name', name: 'Alphabetically' },
    ],
    apllicableFilters: {
      location: true,
      applications: true,
      partnerSolutions: true,
      initiatives: true,
      industries: true,
      partnerLevels: true,
      specialized: true,
      partnerAwards: true,
    },
  },
  mxp: {
    text: 'how to find an Adobe Technology partner.',
    link: 'https://partners.adobe.com/technologyprogram/experiencecloud/partners.html',
    sortingList: [
      { value: 'default', name: 'Default' },
      { value: 'solutionSize', name: 'Number of Solutions' },
      { value: 'assuredprograms', name: 'Number of App Assured' },
      { value: 'level', name: 'Partner level' },
      { value: 'name', name: 'Alphabetically' },
    ],
    apllicableFilters: {
      location: true,
      applications: true,
      partnerSolutions: true,
      initiatives: true,
      industries: true,
      partnerLevels: true,
      specialized: false,
      partnerAwards: true,
    },
  },
};

export default ProgramTypeConfig;
